const Config = {}

Config.loading = <div class="spinner-grow text-info" role="status">
	<span class="sr-only">Loading...</span>
</div>


export default Config